<template>
  <div class="menu-icon" :class="{opended: value, ...classNames}" @click="onClick">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>

<script>
export default {
  name: 'MenuIcon',
  props: ['classNames', 'isOpened', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    onClick () {
      this.$emit('change', !this.value)
    }
  }
}
</script>

<style scoped>
  .menu-icon {
    display: inline-block;
    cursor: pointer;
  }

  .bar1, .bar2, .bar3 {
    width: 22px;
    height: 3px;
    background-color: #ffffff;
    margin: 4px 0;
    transition: 0.4s;
  }

  .opended .bar1 {
    -webkit-transform: rotate(-45deg) translate(-9px, 6px);
    transform: rotate(-45deg) translate(-3px, 9px);
  }

  .opended .bar2 {opacity: 0;}

  .opended .bar3 {
    -webkit-transform: rotate(45deg) translate(-8px, -8px);
    transform: rotate(45deg) translate(0px, -8px);
  }
</style>
